import { Modal } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const StyledModal = styled(Modal)`
  && {
    z-index: 99;
    padding: ${rem(20)};

    div:nth-of-type(2) {
      bottom: env(safe-area-inset-bottom, 0);
      padding: ${rem(20)};

      ${media.tabletSmall} {
        bottom: auto;
      }
    }
  }
`;

export default StyledModal;
